import { prop } from "../../decorators/property";
import { PublisherModel } from "../../desktop/models/publisher";
import { backboneModelProperties } from "../../decorators/backbone-properties";

@backboneModelProperties({
    relations: [{
        type: Backbone.One,
        key: "Publisher",
        relatedModel: PublisherModel
    }]
})
export class FullTextSourceModel extends Backbone.AssociatedModel {
    @prop() public DisplayLink: boolean;
    @prop() public AllAreHidden: boolean;
    @prop() public Description: string;
    @prop() public NoLinks: boolean;
    @prop() public Publisher: PublisherModel;
    @prop() public SiteId: number;
    @prop() public Url: string;

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/full-text-source.ts